import React from "react";

export function LengthCard({ title, subtitle, selected, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`flex flex-col gap-2 w-full p-4 rounded-[8px] border-2 cursor-pointer transition
        ${selected ? "border-black" : "border-gray-150 hover:border-gray-300"}
        bg-white`}
    >
      <div className="flex flex-col gap-1">
        <p className="text-[16px] font-semibold">{title}</p>
        <p className="text-[12px] text-gray-600">{subtitle}</p>
      </div>
    </div>
  );
}
